import CircularCenteredLoader from "features/common/CircularCenteredLoader";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getDisputesForPaginationMuthoot,
} from "slices/disputeSlice";
import DisputesMuthootUser from "./DisputesMuthootUser";
import { ROWS_PER_PAGE } from "./config";
import { usePagination } from "hooks";

export default function DisputesContainerMuthoot() {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile, shallowEqual);
  const user = useSelector((state) => state.user.user);

  const { page, setPage, totalPages, syncWithBackend } = usePagination({
    initialPageSize: ROWS_PER_PAGE,
    initialPage: 1,
  });

  let sessionType = sessionStorage.getItem("muthoot-type");

  const [type, setType] = useState(sessionType ? sessionType : 'open');
  const [disputes, setDisputes] = useState([]);
  const [disputesLoading, setDisputesLoading] = useState(false);

  useEffect(()=>{
    reload(type);
  },[type])


  const reload = (newType = type) => {
    setDisputesLoading(true);
    setPage(1);
    dispatch(getDisputesForPaginationMuthoot(page, newType, null, null)).then((res) => {
      syncWithBackend({ totalCount: res?.count, next: res?.next, previous: res?.previous });
      setDisputes(res.results);
      setDisputesLoading(false);
    });
  };

  const getUserDataAnotherPage = (pageNo) => {
    if(pageNo === page) return;
    setPage(pageNo)
    setDisputesLoading(true);
    dispatch(getDisputesForPaginationMuthoot(pageNo, type, null, null)).then((res) => {
      setDisputes(res.results);
      setDisputesLoading(false);
    });
  };

  let childProps = {
    disputes,
    profile,
    user,
    disputesLoading,
    setType,
    type,
    reload,
    totalPages,
    page,
    setPage,
    getUserDataAnotherPage,
    profile
  };

  if (disputesLoading) return <CircularCenteredLoader />;
  return <DisputesMuthootUser {...childProps} />;
}
